import { render, staticRenderFns } from "./SideBarUser.vue?vue&type=template&id=317dee6e"
import script from "./SideBarUser.vue?vue&type=script&lang=js"
export * from "./SideBarUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports